<template>
  <div class="row">
    <div class="form-group col-xs-6" :class="{ 'has-error': hasErrors() }">
      <label class="control-label"
        >Coordinates
        <span class="optional"
          >(e.g. lat: 34.765672, long: -92.308176)</span
        ></label
      >

      <div class="input-group">
        <span class="input-group-addon">GPS-lat</span>
        <input
          type="text"
          pattern="[-\d\.]+"
          class="form-control"
          v-model="lat"
          :disabled="!inPointMode()"
        />
      </div>

      <div class="input-group">
        <span class="input-group-addon">GPS-lng</span>
        <input
          type="text"
          pattern="[-\d\.]+"
          class="form-control"
          v-model="lng"
          :disabled="!inPointMode()"
        />
      </div>

      <span class="help-block" v-if="hasErrors()" v-text="errors"></span>

      <a @click="editPolygon" class="btn btn-blue">Edit Polygon</a>

      <button
        class="pointer btn btn-blue"
        @click="getShape($event)"
        title="Upload zone shape file"
      >
        <i class="fa fa-map"></i>
      </button>

      <input
        type="hidden"
        class="form-control"
        id="geojson"
        :value="JSON.stringify(geojson)"
      />
    </div>

    <div class="col-xs-6">
      <google-map
        :zoom="10"
        :height="180"
        :draggable="true"
        :hideFilterInfo="true"
        :linkedMap="!editingPolygon ? polyEditorMap : null"
        :withMap="storeMap"
        :center="center"
      >
        <template slot-scope="{ google, map }">
          <map-marker
            :google="google"
            :map="map"
            :editable="inPointMode()"
            :geojson="center"
          />

          <div v-for="path in polygonPaths" :key="JSON.stringify(path)">
            <keep-alive>
              <map-polygon :google="google" :map="map" :path="path" />
            </keep-alive>
          </div>
        </template>
      </google-map>
    </div>

    <input
      type="file"
      id="shape"
      v-on:change="readShape()"
      accept=".zip,application/octet-stream,application/zip,application/x-zip,application/x-zip-compressed"
    />
  </div>
</template>

<script>
import ZonesService from '@/services/ZonesService';
import * as turf from '@turf/turf';
import GoogleMap from '@/components/map/google-map';
import MapMarker from './generic-map-marker';
import MapPolygon from './generic-polygon';
import Point from '@/store/models/point';
import { mapState, mapGetters } from 'vuex';

export default {
  components: {
    GoogleMap,
    MapMarker,
    MapPolygon,
  },

  props: {
    geojsonData: Object,
    errors: String,
  },

  watch: {
    geojsonData: function(value) {
      if (value.geometry) {
        this.$store.commit('setGeoJSON', value);
        this.$store.commit('setCoordinates', this.center);
      }
    },
  },

  computed: {
    ...mapGetters(['coordinateMode', 'center']),

    ...mapState({
      geojson: (state) => state.coordinateEditor.geojson,
      editingPolygon: ({ coordinateEditor }) => coordinateEditor.editingPolygon,
      polyEditorMap: ({ coordinateEditor }) => coordinateEditor.polyEditorMap,
    }),

    lat: {
      get() {
        return this.$store.state.coordinateEditor.lat;
      },

      set(value) {
        this.$store.commit('setLat', value);
      },
    },

    lng: {
      get() {
        return this.$store.state.coordinateEditor.lng;
      },

      set(value) {
        this.$store.commit('setLng', value);
      },
    },

    polygonPaths() {
      if (this.inPointMode()) return [];
      return this.geojson.geometry.coordinates;
    },
  },

  methods: {
    inPointMode() {
      return this.coordinateMode == 'Point';
    },

    inPolygonMode() {
      return this.coordinateMode == 'MultiPolygon';
    },

    hasErrors() {
      return this.errors && this.errors.length > 0;
    },

    editPolygon() {
      this.$store.commit('editingPolygon', true);
    },

    getShape(e) {
      e = e || window.event;
      e.preventDefault();
      document.querySelector('#shape').click();
    },

    readShape() {
      let files = document.querySelector('#shape').files;
      if (!files.length) {
        return;
      }

      var $this = this;
      let fileReader = new FileReader();
      fileReader.onloadend = () => {
        document.querySelector('#shape').value = null;

        ZonesService.shape({ shape: fileReader.result }).then((data) => {
          $this.shapeFile = data.map((d) => {
            return {
              type: d.type,
              properties: {
                contracts: [],
                isSprayZone: false,
                ...d.properties,
              },
              geometry: {
                coordinates: d.geometry.coordinates,
                type: d.geometry.type,
              },
            };
          });

          const combineShapes = (acc, geoJson, index) => {
            const { geometry } = geoJson;
            const coordinates =
              geometry.type === 'Polygon'
                ? geometry.coordinates
                : geometry.coordinates.map((coords) => coords[0]);

            return {
              ...acc,
              geometry: {
                type: 'MultiPolygon',
                coordinates: [...acc.geometry.coordinates, ...coordinates],
              },
            };
          };
          const combinedGeoJson = $this.shapeFile.reduce(combineShapes, {
            geometry: { coordinates: [] },
          });
          $this.$store.commit('setGeoJSON', combinedGeoJson);

          $this.showList = false;
        });
      };
      fileReader.readAsDataURL(files[0]);
    },

    storeMap(map) {
      this.$store.commit('setFormMap', map);
    },

    mapPoints(data) {
      let points = data.map((c) => {
        return { lat: c[1], lon: c[0] };
      });

      return points;
    },
  },
};
</script>
